import "core-js/modules/es.array.reverse.js";
var _dec, _dec2, _class, _class2, _descriptor;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/web.dom-collections.iterator.js";
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import classNames from "classnames";
import { action, makeObservable, observable, runInAction } from "mobx";
import { observer } from "mobx-react";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import hasTraits from "../../../Models/Definition/hasTraits";
import { Button, StyledButton } from "../../../Styled/Button";
import Icon, { StyledIcon } from "../../../Styled/Icon";
import UrlTraits from "../../../Traits/TraitsClasses/UrlTraits";
import Styles from "./chart-expand-and-download-buttons.scss";
import Dropdown from "../../Generic/Dropdown";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let ChartExpandAndDownloadButtons = (_dec = action.bound, _dec2 = action.bound, observer(_class = (_class2 = class ChartExpandAndDownloadButtons extends Component {
  constructor(props) {
    super(props);
    _initializerDefineProperty(this, "sourceItems", _descriptor, this);
    makeObservable(this);
  }
  expandButton() {
    this.expandItem(this.sourceItems.length - 1);
  }
  expandDropdown(_selected, sourceIndex) {
    this.expandItem(sourceIndex);
  }

  /**
   * Expand sourceIndex item by adding it to the workbench.
   *
   * We also remove any existing sourceItems from workbench so that only one
   * source is shown at any time.
   */
  expandItem(sourceIndex) {
    const terria = this.props.terria;
    runInAction(async () => {
      const sourceItems = this.sourceItems;
      const itemToExpand = sourceItems[sourceIndex];
      const workbench = terria.workbench;
      if (!itemToExpand) {
        return;
      }

      // We want to show only one source item at a time, so remove any
      // existing source items from the workbench
      sourceItems.forEach(sourceItem => {
        workbench.items.forEach(workbenchItem => {
          if (sourceItem.uniqueId === workbenchItem.uniqueId) {
            workbench.remove(workbenchItem);
          }
        });
      });
      try {
        terria.addModel(itemToExpand);
      } catch (_unused) {}
      (await workbench.add(itemToExpand)).raiseError(terria, undefined, true);
    });
  }
  resolveSourceItems() {
    Promise.all(this.props.sourceItems.map(sourceItem => Promise.resolve(sourceItem))).then(action(results => {
      this.sourceItems = filterOutUndefined(results);
    }));
  }
  componentDidMount() {
    this.resolveSourceItems();
  }
  componentDidUpdate(prevProps) {
    if (this.props.sourceItems !== prevProps.sourceItems) {
      this.resolveSourceItems();
    }
  }
  render() {
    if (this.sourceItems.length === 0) {
      return null;
    }

    // The downloads and download names default to the sources and source names if not defined.
    const downloads = filterOutUndefined(this.props.downloads || this.sourceItems.map(item => hasTraits(item, UrlTraits, "url") ? item.url : undefined));
    const {
      sourceNames,
      canDownload,
      raiseToTitle,
      t
    } = this.props;
    if (sourceNames && sourceNames.length > 0) {
      const downloadNames = this.props.downloadNames || sourceNames;
      return /*#__PURE__*/_jsx(ExpandAndDownloadDropdowns, {
        sourceNames: sourceNames,
        canDownload: canDownload,
        downloads: downloadNames.map((name, i) => ({
          name,
          href: downloads[i]
        })),
        onExpand: this.expandDropdown,
        raiseToTitle: raiseToTitle,
        t: t
      });
    }
    return /*#__PURE__*/_jsx(ExpandAndDownloadButtons, {
      onExpand: this.expandButton,
      downloadUrl: canDownload && downloads.length > 0 ? downloads[0] : undefined,
      t: t
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "sourceItems", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, "expandButton", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "expandButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "expandDropdown", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "expandDropdown"), _class2.prototype), _class2)) || _class);
const ExpandAndDownloadDropdowns = function (props) {
  const expandDropdownTheme = {
    dropdown: Styles.dropdown,
    list: Styles.dropdownList,
    button: Styles.dropdownBtn,
    btnOption: Styles.dropdownBtnOption
  };
  const downloadDropdownTheme = _objectSpread(_objectSpread({}, expandDropdownTheme), {}, {
    button: classNames(Styles.btnSmall, Styles.btnDownload)
  });
  return /*#__PURE__*/_jsxs(ExpandAndDownloadContainer, {
    raiseToTitle: props.raiseToTitle,
    children: [/*#__PURE__*/_jsx(Dropdown, {
      selectOption: props.onExpand,
      options: props.sourceNames.map(name => ({
        name
      })),
      theme: expandDropdownTheme,
      children: props.t("chart.expand") + " ▾"
    }), props.canDownload && /*#__PURE__*/_jsx(Dropdown, {
      options: props.downloads,
      theme: downloadDropdownTheme,
      children: props.t("chart.download") + " ▾"
    })]
  });
};
const ExpandAndDownloadButtons = function (props) {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(ExpandAndDownloadContainer, {
    children: [/*#__PURE__*/_jsx(ButtonChartExpand, {
      type: "button",
      onClick: props.onExpand,
      children: props.t("chart.expand")
    }), props.downloadUrl && /*#__PURE__*/_jsx(DownloadLink, {
      download: true,
      href: props.downloadUrl,
      children: /*#__PURE__*/_jsx(StyledIcon, {
        fillColor: theme.textLight,
        glyph: Icon.GLYPHS.download
      })
    })]
  });
};
const ExpandAndDownloadContainer = styled.div.withConfig({
  displayName: "ChartExpandAndDownloadButtons__ExpandAndDownloadContainer",
  componentId: "sc-1voa47t-0"
})(["display:flex;flex-direction:row;justify-content:flex-end;", ""], props => props.raiseToTitle && "margin-top: -21px;");
const ButtonChartExpand = styled(Button).attrs({
  primary: true
}).withConfig({
  displayName: "ChartExpandAndDownloadButtons__ButtonChartExpand",
  componentId: "sc-1voa47t-1"
})(["border-radius:3px;padding:1px 8px;min-height:unset;margin-right:5px;"]);
const DownloadLink = styled(StyledButton).attrs(() => ({
  as: "a",
  primary: true
})).withConfig({
  displayName: "ChartExpandAndDownloadButtons__DownloadLink",
  componentId: "sc-1voa47t-2"
})(["text-decoration:none;border-radius:2px;padding:1px 8px;min-height:unset;svg{height:20px;width:20px;}"]);
export default withTranslation()(ChartExpandAndDownloadButtons);